const env = require("app/services/env");
const Step = require("app/components/checkout/steps/Step").default;
const {groupProductItems} = require("app/util/cart");
const ProductItem = require("app/components/checkout/mixins/ProductItem");
const router = require("app/services/router");
const {numberFormat} = require("app/util/formaters");
const moment = require('moment');
const Confirm = require("app/components/modals/Confirm");
const DiscountWidget = require("app/components/widgets/DiscountWidget");
const truncateText = require("app/util/truncateText");
const axios = require("axios");
const Trans = require('app/components/trans/Trans')

/////////////////////////////////
// Item
/////////////////////////////////

class Item extends ProductItem {

	get className() {
		return super.className + " overview-product-item";
	}

	isFuneral() {
		return this.props.productType === "funeral";
	}

	renderBody() {
		return (
			<div className="item-body">
				<div className="thumbnail">
					<img src={this.props.thumbnail} alt={this.props.name}/>
				</div>
				<div className="info">
					<div className="title">{this.props.name}</div>
					{this.renderDescription()}
				</div>
				{this.renderCardText()}
			</div>
		);
	}

	renderCardText(){
		if (this.props.textCard != 8 && this.props.cardText != null) {
			return (
				<div className="card-text">
					<p className="title"><Trans>Korttekst</Trans></p>
					<p>{this.props.cardText}</p>
				</div>
				);
		}

		return
	}

	renderBandColumn() {
		if (!this.isFuneral()) {
			return;
		}

		return (
			<td data-th={ translate("Bånd" ) } >{numberFormat(this.props.extras.ribbon)}</td>
		);
	}

	render() {
		return (
			<tr className={this.className}>
				<td data-th={ translate("Produkt") } >{this.renderBody()}</td>
				<td data-th={ translate("Pris") }>{numberFormat(this.props.price)}</td>
				<td data-th={ translate("Kort")} >{numberFormat(this.props.extras.card)}</td>
				{this.renderBandColumn()}
				<td data-th={ translate("Total") } >{numberFormat(this.total)}</td>
			</tr>
		);
	}

}

/////////////////////////////////
// Item Mobile
/////////////////////////////////

class ItemMobile extends ProductItem {

	get textCardName() {
		if (typeof this.props.textCard !== "number") {
			return;
		}

		const cardData = env.get("checkout.textCards", []).filter(card => card.id === this.props.textCard).pop();
		return cardData ? cardData.name : null;
	}

	renderCardInfo() {
		if (this.props.textCard == undefined) {
			return;
		}

		return (
			<div className="text-card-info">
				<div>
                  <Trans>Korttype</Trans>: <span>{this.textCardName || translate('Ingen') }</span>
					{!this.props.cardText ? <span className="missing-text"> | <span><Trans>Ingen tekst</Trans></span></span> : <span className="card-text-preview"> | {truncateText(this.props.cardText, 18)}</span>}
				</div>
			</div>
		);
	}

	renderBody() {
		return (
			<div className="item-body">
				<div className="thumbnail">
					<img src={this.props.thumbnail} alt={this.props.name} className="main" />
				</div>
				<div className="details">
					<div className="details-inner">
						<div className="info">
							<div className="title">
								<div className="the-title">{this.props.name}</div>
							</div>
							{this.renderDescription()}
						</div>
						<div className="price">{numberFormat(this.total)}</div>
					</div>
					{this.renderCardInfo()}
				</div>
			</div>
		);
	}

}

/////////////////////////////////
// Step
/////////////////////////////////


class Overview extends Step {

	get defaultState() {
		return {
			discountError: null
		};
	}

	onPrev() {
		return new Promise((resolve, reject) => {
			if (this.cart.status === "expecting_payment") {
				this.pipelines.clear.request.dispatch()
					.then(() => {
						this.setState({submitting: false}, () => {
							resolve();
						});
					})
					.catch(() => {
						this.setState({submitting: false}, () => {
							reject();
						});
					});
			} else {
				resolve();
			}
		});

	}

	onNext() {
		return new Promise((resolve, reject) => {

			if (this.cart.status === "expecting_payment") {
				window.location = router.route("checkout.payment", {guid: this.cart.guid});
				return reject();
			}

			let error = [];

			if (this.cart.client.name === this.cart.recipient.name) {
				error.push( translate('navn'));
			}

			if (this.cart.client.address === this.cart.recipient.address) {
				error.push( translate('adresse') );
			}

			let message = translate(' "Modtager" og "afsender" har samme ') + error.join(translate(' og ')) + translate(', er dette korrekt?');

			if (this.cart.client.name === this.cart.recipient.late_name) {
				error.push("late_name")
				message = translate('"Afsender" og "Afdødes navn" er ens, er dette korrekt?') ;
			}

			if (error.length > 0) {
				//render warning
				this.modal
					.await(message)
					.then((e) => {
						return resolve();
					}).catch(() => {
					this.props.forceStep(1);
					return reject();
				})
			} else {
				return resolve();
			}

		}).then(() => {
			return axios.post(
				router.route("api.tracking.checkout-overview-completed"),
				{cart_id: this.cart.guid}
			);
		});
	}

	get title() {
		return <Trans>Overblik</Trans>;
	}

	get gaInfo(){
		return {
			'page_title' : translate('Ser overblik') ,
			'page_path': translate('/ser-overblik/')
		};
	}

	get description() {
		return "";
	}

	get baseClassName() {
		return "step-overview";
	}

	isFuneral() {
		return this.cart.productType === "funeral";
	}

	renderNextButton() {
		if (router.currentRoute === "checkout.product.payment") {
			return;
		}

		return super.renderNextButton();
	}

	toggleInfo = e => {
		const clickedElement = e.currentTarget
		const toggleElement = clickedElement.querySelector('.contact-content')
		const contentElement = clickedElement.querySelector('.contact-content-inner')

		if (!toggleElement.style.maxHeight ) {
			toggleElement.style.maxHeight = contentElement.offsetHeight + 'px'
			clickedElement.classList.add('open')
		} else {
			toggleElement.style.maxHeight = ''
			clickedElement.classList.remove('open')
		}
	}

	renderContact(title, contact, extras = null) {
        const cvrParagraph = contact.cvr ? (<p><Trans>CVR nr.: </Trans>{contact.cvr}</p>) : null;
		const lateName = contact.late_name ? (<p><Trans>Afdødes navn</Trans>: {contact.late_name}</p>) : null;
		return (
			<div className="contact">
				<div onClick={e => this.toggleInfo(e)}>
					<div className="contact-title">{title}</div>
					{lateName}
					<div className="contact-content">
						<div className="contact-content-inner">
                          <p>{contact.name}</p>
                          <p>{contact.address}</p>
                          <p>{contact.zipcode} {contact.city} </p>
                          <p>{env.get('options.show_region_field', false) ? contact.region : ""}</p>
                          <p>{contact.phone}</p>
                          <p>{contact.email}</p>
                          <p>{contact.company}</p>
                          {cvrParagraph}
                          {extras}
                        </div>
					</div>
				</div>
			</div>
		);
	}

	renderItems() {
		return groupProductItems(this.cart.items).map(item => {
			const itemId = item.id instanceof Array ? item.id.join("|") : item.id;
			const key = `${itemId}@${item.price}`;

			return (<Item key={key} {...item}/>)
		});
	}

	renderItemsMobile() {
		return groupProductItems(this.cart.items).map(item => {
			const itemId = item.id instanceof Array ? item.id.join("|") : item.id;
			const key = `m_${itemId}@${item.price}`;

			return (<ItemMobile key={key} {...item}/>)
		});
	}

	renderLine(title, description = "", value = 0.0) {
		return (
			<div className="basket-line price-line">
				<div className="line-title">
					{title}
					<span>{description}</span>
				</div>
				<div className="line-body">{numberFormat(value)}</div>
			</div>
		);
	}

	renderSubtotal() {
		return this.renderLine(
            translate('Subtotal (:currencyCode)', {currencyCode: env.get('currency.alpha_code')}),
            translate('Heraf moms: :vatValue', {vatValue: numberFormat(this.cart.price.vat)}),
			this.cart.price.subtotal
		);
	}

	onDiscountChange = (value) => {
		return this.pipelines.discount.update.dispatch({code: value}).then(() => {
			this.setState({discountError: null});
		}).catch(error => {
			this.setState({
				discountError: error.response.data.message
			});
		});
	};

	renderDiscount() {
	    const discounts = this.cart.discount ?
			this.renderLine(translate('Gavekort - Rabatkode'), "", this.cart.price.discount) : null;

	    return (
	        <React.Fragment>
				<div className="widgets">
					<DiscountWidget value={this.cart.discount} error={this.state.discountError} onChange={this.onDiscountChange}/>
				</div>
				{discounts}
			</React.Fragment>
		);
	}

	renderBandColumn() {
		if (!this.isFuneral()) {
			return;
		}

		return (
			<td><Trans>Bånd</Trans></td>
		);
	}

	get deliveryDateText() {
		if (this.isFuneral()) {
			return moment(`${this.cart.deliveryDate} ${this.cart.deliveryTime}`, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY [Kl.] HH:mm");
		}
		return moment(`${this.cart.deliveryDate}`, "YYYY-MM-DD").format("DD.MM.YYYY")+(this.deliveryDateUncertain);
	}
	
	get occasionName() {
		if (this.isFuneral()) {
			return translate('Begravelse');
		}
		let occasion = env.get('checkout.occasions', []).filter(occasion => occasion.id === this.cart.occasion).pop();
		return occasion ? occasion.name : "none";
	}

	get deliveryDateUncertain(){
		if(this.state.uncertainDate){
			return <span><Trans>(Ikke garanteret)</Trans></span>;
		} else {
			return "";
		}
	}

	renderOrderFooter() {
		return (
			<div className="order-footer hide-desktop" style={{transform: `translateX(300%)`}}>
				<div className="order-footer__content">
					<div>
						<div className="order-footer__title"><Trans>Varer</Trans> - {numberFormat(this.cart.price.subtotal)}</div>
						<div className="order-footer__subtitle">{this.cart.price.delivery <= 0 ? translate('Afhentning') : translate('Udbringning')} - {numberFormat(this.cart.price.delivery)}</div>
					</div>
					<div className="order-footer__border">
					</div>
					<div className="order-footer__price">
						{numberFormat(this.cart.price.total)}
					</div>
					<div>
						<button onClick={() => this.next()}>
						</button>
					</div>
				</div>
      </div>
		)
	}

	renderStep() {
		return (
			<div>
				<div className="contacts">
					{this.renderContact(translate('Kunde'), this.cart.client, (
						<div>
							<p>{this.cart.options.anonymous ? translate('Anonymitet tilvalgt'):""}</p>
							<p>{this.cart.notes}</p>
						</div>
						)
					)}
					{this.cart.recipients.map(recipient => this.renderContact(translate('Leveringsdetaljer'), recipient, (
						<div key={this.occasionName}>
                            <p><Trans>Leveringsdato</Trans>: {this.deliveryDateText}{this.props.getWarning ? translate('(Efter deadline)'):""}</p>
                            <p><Trans>Anledning</Trans>: {this.occasionName}</p>
                            <p>
                              {this.cart.recipient.can_leave_at_door
                                ? translate('Må sættes ved døren')
                                : translate('Må ikke sættes ved døren')
                              }
                            </p>
                            <p>
                              {this.cart.recipient.can_leave_at_neighbour
                                ? translate('Må afleveres ved naboen')
                                : translate('Må ikke afleveres ved naboen')
                              }
                            </p>
						</div>
						)
					))}
				</div>
				<table className="overview-table">
					<thead>
					<tr>
						<td><Trans>Produkt</Trans></td>
						<td><Trans>Pris</Trans></td>
						<td><Trans>Kort</Trans></td>
						{this.renderBandColumn()}
						<td><Trans>Total</Trans></td>
					</tr>
					</thead>
					<tbody>{this.renderItems()}</tbody>
				</table>
				<div className="overview-products-mobile item-list">
					<div className="section-title"><Trans>Produkter</Trans></div>
					{this.renderItemsMobile()}
				</div>
				{this.renderDiscount()}
				{this.renderSubtotal()}
				{this.renderLine(translate('Leveringstype - ') + (this.cart.price.delivery <= 0 ? translate('Afhentning') : translate('Udbringning')), "", this.cart.price.delivery)}
				{this.renderLine("Total", "", this.cart.price.total)}
				<Confirm ref={el => this.modal = el} containerRefId="modalContainerCart" confirm={ translate("Jeg bekræfter") } cancel= { translate("Ret oplysninger")} />
				{this.renderOrderFooter()}
			</div>
		);
	}

}

module.exports = Overview;
